import PublicHomepage from '@/components/public-home/PublicHomepage'

export default function Home() {
  return <PublicHomepage />
}
